export default __webpack_public_path__ + "b224c4217a2804408270da6bfdd03aaf.png";